import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SystemText } from '@salesperformanceint/e4shared';
import { load, add, update, remove } from 'actions/admin';
import SimpleAdmin, { DefaultOptions } from 'components/simpleAdmin';

export const AdminTags = ({ history, ...props }) => {
    const dispatch = useDispatch();

    const admin = useSelector(state => state.user.user?.sys_Config);
    const data = useSelector(state => state.admin.tags);

    const onLoad = () => {
        dispatch(load('tag'));
    };

    const onAdd = (entity, callback) => {
        dispatch(add('tag', entity, null, callback));
    };

    const onUpdate = (entity, callback) => {
        dispatch(update('tag', entity, null, callback));
    };

    const onRemove = (ids, callback) => {
        if (!Array.isArray(ids)) ids = [ids];
        ids.forEach((id, idx) => {
            dispatch(remove('tag', id, () => idx + 1 === ids.length && callback()));
        });
    };

    useEffect(() => {
        onLoad();
    }, []);

    if (!admin) history.replace('/');

    const options = {
        ...DefaultOptions(),
        label: SystemText('Admin/Tags/Label/Options'),
    };

    const fields = [
        {
            label: SystemText('Admin/Tags/Fields/Label/Options'),
            type: 'text',
            mandatory: true,
            dataProperty: 'name',
            maxLength: 50,
            generalErrors: true,
            uniqueErrors: true,
            help: SystemText('Admin/Tags/Fields/Help/Options'),
        },
    ];

    const tableColumns = [{ label: SystemText('Admin/Tags/Table/Columns/Label'), dataProperty: 'name' }];

    return (
        <div data-testid="admin-tags-wrapper-testid">
            <SimpleAdmin
                {...props}
                data={data}
                add={onAdd}
                load={onLoad}
                update={onUpdate}
                remove={onRemove}
                fields={fields}
                options={options}
                columns={tableColumns}
            />
        </div>
    );
};

export default AdminTags;
